import { Injectable } from '@angular/core';

import { TaskMapper } from '../contracts/task-mapper.contract';
import { TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

@Injectable()
export class ProcessGuaranteeApplicationTaskMapper implements TaskMapper<TaskType.ProcessGuaranteeApplication> {
  readonly type = TaskType.ProcessGuaranteeApplication;

  map(r: TaskResponse): TaskDataMap[TaskType.ProcessGuaranteeApplication] {
    return {
      description: r.data?.['description'] ?? '',
      doctorName: r.data?.['doctorName'] ?? '',
      guaranteeId: r.data?.['guaranteeApplicationId'] ?? '',
      memberId: r.data?.['memberId'] ?? '',
      memberName: r.data?.['memberName'] ?? '',
    };
  }
}
